import EventEmitter from 'events';

export enum CopilotEmitterEvent {
  FocusCopilotMessageBox = 'focusCopilotMessageBox',
}

export const copilotEventEmitter = new EventEmitter();
